import React, { FC } from 'react';

import { useFeatureLayout } from 'features/content/hooks/use-feature-layout';

import Picture from 'components/picture';
import { t } from 'state/intl/translations';

const GiftCardImage: FC = () => {
  const { featureLayout } = useFeatureLayout();
  const giftCardImage = featureLayout?.giftCardImage?.locale;

  return giftCardImage ? (
    <Picture
      image={giftCardImage}
      alt={t('giftCard')}
      objectFitContain
      width="300px"
      height="162px"
      mb="$8"
    />
  ) : null;
};

export default React.memo(GiftCardImage);
